import cn from 'classnames';

import styles from './error.module.scss';

const Error: React.FC<
  React.PropsWithChildren<{
    readonly className?: string;
  }>
> = ({ children, className }) => {
  return <div className={cn(styles.container, className)}>{children}</div>;
};

export default Error;
